import styled from 'styled-components';
import { Colors, Media } from 'enums';
import { Icon } from 'view/atoms';

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${Media.notebook} {
    align-items: center;
  }
`;

export const ButtonWrapper = styled.div<{ isExpanded: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 12px;
  border-radius: 8px;
  transition: none;
  background-color: ${({ isExpanded }) =>
    isExpanded ? Colors.yellow1 : Colors.background};
  &:hover {
    background-color: ${({ isExpanded }) =>
      isExpanded ? Colors.yellow1 : Colors.white};
  }
  @media ${Media.notebook} {
    padding: 20px;
  }
`;

export const FlippedIcon = styled(Icon)`
  rotate: 180deg;
`;

export const DropdownInnerWrapper = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: 45px;
  @media ${Media.notebook} {
    margin: 10px 0 0 60px;
    justify-content: center;
  }
`;

export const CategoryOption = styled.div`
  padding: 14px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
`;
export const DropdownLeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;
